import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../components/base/base.component';
import { ProductsService } from '../../../_services/products/products.service';
import IProduct from '../../../_interfaces/IProduct';
import { SessionService } from '../../../_services/session/session.service';
import { TableModule } from 'primeng/table';
import { ProductImageComponent } from '../../../components/product-image/product-image.component';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { AdminTableActionsComponent } from '../../admin-ui/admin-table-actions/admin-table-actions.component';
import { AdminListToolbarComponent } from '../../admin-ui/admin-list-toolbar/admin-list-toolbar.component';
import { AdminStatePanelComponent } from '../../admin-ui/admin-state-panel/admin-state-panel.component';

@Component({
  standalone: true,
  selector: 'app-table-products',
  templateUrl: './table-products.component.html',
  styleUrls: ['./table-products.component.scss'],

  imports: [
    CommonModule,
    ButtonModule,
    TableModule,
    ProductImageComponent,
    TranslatePipe,
    AdminTableActionsComponent,
    AdminListToolbarComponent,
    AdminStatePanelComponent,
  ],
})
export class TableProductsComponent extends BaseComponent implements OnInit {
  public products: IProduct[] = [];
  public filteredProducts: IProduct[] = [];
  public searchValue = '';

  constructor(
    private productsService: ProductsService,
    private messageService: MessageService,
    private errorsService: ErrorsService,
    private confirmationService: ConfirmationService,
    public translate: TranslateService,
    public session: SessionService,
    public router: Router,
  ) {
    super(session);
  }

  load() {
    this.productsService.getAllByCustomer(this.customers_id).subscribe({
      next: (products: IProduct[]) => {
        this.products = products;
        this.onSearch(this.searchValue);
      },
      error: (err: HttpErrorResponse) => {
        const code = this.errorsService.getMessageFromTreatmentError(err);
        this.messageService.add({
          severity: 'error',
          detail: this.translate.instant(`MESSAGES.PRODUCTS.ERROR.${code}`),
          summary: this.translate.instant(`MESSAGES.PRODUCTS.ERROR.SUMMARY`),
        });
      },
    });
  }

  onSearch(value: string): void {
    this.searchValue = value;
    const query = value.trim().toLowerCase();
    if (!query) {
      this.filteredProducts = [...this.products];
      return;
    }
    this.filteredProducts = this.products.filter((product) =>
      [product.name, product.description, product?.category?.name]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .includes(query),
    );
  }

  confirmDelete(product: IProduct): void {
    this.confirmationService.confirm({
      header: this.translate.instant('ADMIN.PRODUCTS.CONFIRM.DELETE.TITLE', {
        product: product.name,
      }),
      message: this.translate.instant('ADMIN.PRODUCTS.CONFIRM.DELETE.TEXT', {
        product: product.name,
      }),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.delete(product),
    });
  }

  private delete(product: IProduct): void {
    this.productsService.delete(this.customers_id, product.id as number).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          detail: this.translate.instant('MESSAGES.PRODUCTS.DELETE.DETAIL', {
            product: product.name,
          }),
          summary: this.translate.instant('MESSAGES.PRODUCTS.DELETE.SUMMARY'),
        });
        this.load();
      },
      error: (err: HttpErrorResponse) => {
        const code = this.errorsService.getMessageFromTreatmentError(err);
        this.messageService.add({
          severity: 'error',
          detail: this.translate.instant(`MESSAGES.PRODUCTS.ERROR.${code}`),
          summary: this.translate.instant('MESSAGES.PRODUCTS.ERROR.SUMMARY'),
        });
      },
    });
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.load();
  }
}
